module.exports = "https://trybtryb-legacy.web.app/img/stripe.eefee046.svg";